import styled from "styled-components";
import { colorMixin, spacingMixin, typographyMixin } from "../../../helpers";

export const Breadcrumbs = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${spacingMixin(2)};
    ${typographyMixin("label-small-medium")}
    color: ${colorMixin("text-primary-700")};
`;

export const Breadcrumb = styled.span.withConfig({
    shouldForwardProp: (prop, validAttr) => validAttr(prop)
})`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: ${colorMixin("text-primary-900")};
    text-decoration: none;
`;

export const BreadcrumbChevron = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colorMixin("text-primary-300")};
`;
